import { IConfigurationRegistry } from "../../../../base/domain/configuration";
import { IConfiguration } from "../../../domain/configuration";
import {
  IEditableFormatRegistry,
  IFormatSpecificationRepository,
  IEditableFormatRepository,
  IEditableFormatDocumentRepository,
  IEditableFormatClipboardRepository,
} from "../../../domain/editableFormat";
import { FormatSpecificationRepository } from "./FormatSpecificationRepository";
import { EditableFormatRepository } from "./EditableFormatRepository";
import { EditableFormatDocumentRepository } from "./EditableFormatDocumentRepository";
import { EditableFormatClipboardRepository } from "./EditableFormatClipboardRepository";

export class EditableFormatRegistry implements IEditableFormatRegistry {
  constructor(getToken: () => string, configurationRegistry: IConfigurationRegistry<IConfiguration>) {
    this._specificationRepository = new FormatSpecificationRepository(getToken);
    this._formatRepository = new EditableFormatRepository(getToken, configurationRegistry);
    this._documentRepository = new EditableFormatDocumentRepository(getToken);
    this._clipboardRepository = new EditableFormatClipboardRepository(configurationRegistry);
  }

  private readonly _specificationRepository: IFormatSpecificationRepository;
  private readonly _formatRepository: IEditableFormatRepository;
  private readonly _documentRepository: IEditableFormatDocumentRepository;
  private readonly _clipboardRepository: IEditableFormatClipboardRepository;

  getSpecificationRepository(): IFormatSpecificationRepository {
    return this._specificationRepository;
  }

  getFormatRepository(): IEditableFormatRepository {
    return this._formatRepository;
  }

  getDocumentRepository(): IEditableFormatDocumentRepository {
    return this._documentRepository;
  }

  getClipboardRepository(): IEditableFormatClipboardRepository {
    return this._clipboardRepository;
  }
}
